import React, {Component} from 'react';
import Home from './Home';
import Projects from './Projects';
import Research from './Research';
import Teaching from './Teaching';

class SectionHost extends Component {

    constructor(props) {

        super(props);

        this.state = {
            ready: false,
            error: false,
            retrying: true,
            section: props.section
        };

        this.wip = <div className="Spinner"/>;

    }

    componentWillReceiveProps(nextProps){

        if(nextProps.section!==this.state.section) {
            this.setState({
                ready: false,
                error: false,
                retrying: true,
                section: nextProps.section
            });
        }

    }

    render() {

        var visibilityClass = this.state.ready?"Visible":"Hidden";
        var sectionComponent = this.loadSection(this.state.section);

        return <div className="Content">

            {
                this.state.ready?undefined:<div>
                    {this.state.retrying?this.wip:undefined}
                    {this.state.error?<div className="Error">{this.downloadErrorString(this.state.retrying)}</div>:undefined}
                </div>
            }

                <div className={visibilityClass+(this.state.section==="Home"?" vCenter":"")}>{sectionComponent}</div>

        </div>

    }

    loadSection(section){

        switch(section) {

            case "Home":
                return <Home readyCallback={this.getReadyCallback()}/>

            case "Projects":
                return <Projects readyCallback={this.getReadyCallback()}/>

            case "Research":
                return <Research readyCallback={this.getReadyCallback()}/>

            case "Teaching":
                return <Teaching readyCallback={this.getReadyCallback()}/>

            default:
                return <div>Section not implemented</div>

        }

    }

    getReadyCallback() {

        var caller = this;
        return (ready, retry)=> {

            caller.setState({
                ready: ready,
                error: !ready,
                retrying: retry
            });

        }

    }

    downloadErrorString(retry){

        if(retry){
            return <p>I couldn't load this section...<br/>I will try again in a few seconds!</p>
        }else{
            return <p>I did my best but it wasn't enough...<br/>I won't load this section. Refresh the page to try again!</p>
        }
    }

}

export default SectionHost;



// WEBPACK FOOTER //
// ./src/SectionHost.js